import { Link, NavLink, Outlet } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";

const bottomItems = [
  { to: "/", label: "首页", icon: "ri-home-5-line", end: true },
  { to: "/category/电影", label: "分类", icon: "ri-apps-2-line" },
  { to: "/special", label: "专题", icon: "ri-bookmark-3-line" },
  { to: "/favorites", label: "收藏", icon: "ri-heart-3-line" },
];

export default function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteNavbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <SiteFooter />

      {/* Mobile bottom action bar */}
      <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-background-200 bg-background-50/95 backdrop-blur lg:hidden">
        <div className="grid grid-cols-4">
          {bottomItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `flex flex-col items-center gap-0.5 py-2.5 text-[11px] font-medium transition-colors ${
                  isActive ? "text-primary-700" : "text-foreground-500"
                }`
              }
            >
              <i className={`${item.icon} text-lg`} />
              {item.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}